import {commonFunctions} from 'common-types'

const getBreakpointMediaQuery = (breakpointIdToMediaQuery, breakpointId) =>
    breakpointIdToMediaQuery[breakpointId]

export const functionLibrary = {
    getBreakpointMediaQuery
}

export type FunctionLibrary = typeof functionLibrary & commonFunctions
